const it = {
  brand: "ECLENIA",
  brandSub: "Corporate Health & Workplace Wellbeing",
  nav: {
    home: "Home",
    about: "Founder",
    approach: "Approccio",
    expertise: "Competenze",
    insights: "Insights",
    resources: "Risorse",
    contact: "Contatti",
    cta: "Prenota una Discovery Call",
    menu: "Menu",
    close: "Chiudi",
  },
  home: {
    hero: {
      kicker: "Consulenza Strategica · Salute e Benessere Aziendale",
      titleA: "Corporate Health",
      titleEm: "Workplace Wellbeing",
      subtitle:
        "Aiutiamo le aziende a migliorare il benessere dei dipendenti, per aumentare le performance e ottimizzare il work-life balance.",
      ctaPrimary: "Prenota una Discovery Call",
      ctaSecondary: "Scopri il nostro metodo",
      badge: "Scienza clinica · Pensiero strategico · Organizzazioni centrate sulle persone",
      imageAlt: "Dialogo strategico tra consulente e direzione aziendale",
    },
    marquee: [
      "Corporate Health",
      "Workplace Wellbeing",
      "Organizational Health",
      "Health Strategy",
      "Prevenzione basata sulle evidenze",
      "Employee Experience",
      "Leadership & Wellbeing",
      "Health Culture",
    ],
    stats: {
      kicker: "Le evidenze",
      title: "La salute delle persone è una metrica di business",
      items: [
        { value: "fino a -51%", label: "Turnover volontario", source: "Gallup, Q12® Meta-Analysis" },
        { value: "fino a -78%", label: "Assenteismo", source: "Gallup, Q12® Meta-Analysis" },
        { value: "+14–18%", label: "Produttività", source: "Gallup, State of the Global Workplace" },
        { value: "+21–23%", label: "Profittabilità", source: "Gallup, Q12® Meta-Analysis" },
      ],
      footnote:
        "Dati riferiti al confronto tra organizzazioni nel quartile superiore e inferiore di engagement. Fonte: Gallup, Q12® Meta-Analysis, 11ª edizione (maggio 2024), e State of the Global Workplace.",
    },
    businessCase: {
      kicker: "L'impatto economico",
      title: "Perché conviene alle aziende",
      intro:
        "Il benessere organizzativo non è un benefit accessorio: è una leva economica misurabile, che agisce su costi, continuità operativa e capacità di attrarre talenti. Lo vediamo confermato in ogni organizzazione con cui lavoriamo.",
      highlight: {
        value: "≈ 10.000 miliardi di $",
        text: "Il costo del basso engagement per l'economia globale — il 9% del PIL mondiale (dati 2025)",
        source: "Fonte: Gallup, State of the Global Workplace 2026",
      },
      blocks: [
        {
          title: "Meno costi di turnover",
          text: "Sostituire una persona costa tra il 50% e il 200% della sua retribuzione annua. Investire in salute e prevenzione riduce alla radice una delle voci di costo più sottovalutate.",
          source: "Fonte: Gallup",
        },
        {
          title: "Meno assenteismo e presenteismo",
          text: "Il presenteismo — essere presenti sul lavoro senza essere pienamente produttivi — costa spesso più dell'assenteismo. La salute delle persone si riflette direttamente su continuità operativa, presenza e qualità del lavoro. Prevenire costa meno che assorbire.",
          source: null,
        },
        {
          title: "Retention e talent attraction",
          text: "Un ambiente di lavoro in salute diventa leva di employer branding: trattiene le persone migliori e attrae chi cerca organizzazioni credibili.",
          source: null,
        },
        {
          title: "Conformità normativa",
          text: "La normativa europea impone la tutela della salute dei lavoratori (Direttiva 89/391/CEE); l'obbligo di valutare specificamente il rischio psicosociale è stato reso esplicito dall'Accordo Quadro Europeo sullo Stress Lavoro-Correlato (2004) e, in Italia, dall'art. 28 del D.Lgs. 81/2008. Un approccio strutturato riduce l'esposizione.",
          source: "D.Lgs. 81/2008, Art. 28 · Accordo Quadro UE 2004",
        },
      ],
      cta: "Prenota una Discovery Call",
    },
    areas: {
      kicker: "Aree di intervento",
      title: "Le aree in cui operiamo",
      link: "Vedi tutte le 11 aree di competenza",
      items: [
        { title: "Corporate Health", text: "Strategie integrate di salute aziendale, dalla diagnosi dei bisogni alla governance del benessere." },
        { title: "Organizational Wellbeing", text: "Misurazione e sviluppo del benessere organizzativo: clima, carichi, relazioni." },
        { title: "Healthy Workplace Strategy", text: "Strategie di lungo periodo che integrano salute, prevenzione e obiettivi di business." },
        { title: "Women's Health at Work", text: "La salute delle donne nel ciclo di vita lavorativo come leva di equità e performance." },
        { title: "Prevenzione muscoloscheletrica", text: "Programmi di prevenzione basati su evidenze per i disturbi muscoloscheletrici legati al lavoro." },
        { title: "Ergonomia", text: "Progettazione ergonomica di postazioni, ambienti e processi, in ufficio e in ibrido." },
      ],
    },
    method: {
      kicker: "Cosa offriamo",
      title: "La consulenza in 4 fasi",
      link: "Scopri il metodo completo",
      phases: [
        { n: "01", text: "Valutazione e diagnosi della salute organizzativa, con questionari validati" },
        { n: "02", text: "Report aziendale su tre livelli — persona, team, organizzazione" },
        { n: "03", text: "Piano di intervento condiviso con HR e direzione, con obiettivi verificabili" },
        { n: "04", text: "Monitoraggio continuo dei risultati come indicatore gestionale" },
      ],
    },
    quote: {
      text: "Un'organizzazione in salute non nasce dai benefit. Nasce da decisioni strategiche basate su dati, scienza e rispetto per le persone.",
      author: "Alessia Zanella, Founder di Eclenia",
    },
    finalCta: {
      title: "Costruiamo luoghi di lavoro in salute.",
      text: "Ti proponiamo una conversazione di 30 minuti per capire dove si trova oggi la tua organizzazione e dove può arrivare.",
      cta: "Prenota una Discovery Call",
    },
  },
  about: {
    kicker: "Founder",
    title: "Dalla scienza clinica alla strategia d'impresa",
    intro:
      "Il mio lavoro nasce da una convinzione semplice: la salute delle persone è l'infrastruttura invisibile di ogni organizzazione che performa. Per comprenderla davvero, però, serve prima saperla leggere — ed è lì che inizia il mio percorso.",
    chapters: [
      {
        n: "01",
        period: "Oggi",
        title: "Work Wellbeing / Corporate Health Consultant",
        body: "Oggi lavoro come consulente strategica freelance al fianco di aziende e organizzazioni che vogliono costruire un luogo di lavoro in salute. Porto nelle stanze delle decisioni la stessa disciplina con cui si legge un caso clinico: osservare, misurare, diagnosticare, intervenire, verificare. La clinica mi ha insegnato il metodo. La strategia gli ha dato scala.",
        skill: "Consulenza strategica · Governance del benessere",
      },
      {
        n: "02",
        period: "2021 — 2022",
        title: "La svolta europea",
        body: "La formazione europea in Work-Wellbeing Management (programma Erasmus+ KA202) ha dato un nome e un metodo a ciò che avevo imparato sul campo: portare la salute dentro la strategia delle organizzazioni. Non più interventi puntuali, ma sistemi di prevenzione progettati, misurati, governati.",
        skill: "Pensiero strategico · Prospettiva internazionale",
      },
      {
        n: "03",
        period: "In parallelo",
        title: "Leadership oltre i confini dell'organizzazione",
        body: "Il coordinamento di professionisti sanitari e la leadership in ambito sportivo — squadre, atlete, famiglie, insegnanti — mi hanno messa di fronte a ecosistemi umani molto diversi tra loro. Ogni contesto richiedeva un linguaggio diverso, una negoziazione diversa, una fiducia da costruire. È stata la palestra della mia intelligenza relazionale e della capacità di comunicare con interlocutori molto lontani tra loro.",
        skill: "Comunicazione · Intelligenza relazionale",
      },
      {
        n: "04",
        period: "2017 — 2021",
        title: "Costruire e guidare un'organizzazione",
        body: "La responsabilità dell'apertura della sede di Bassano del Grappa per un centro medico con quattro sedi tra Padova e Bassano ha trasformato la mia prospettiva. Guidare un team di dieci persone, costruire processi da zero, ottenere la certificazione ISO 9001:2015: in quattro anni le richieste sono cresciute del 200% nel primo anno, l'assenteismo interno è sceso dal 35% al 21%, l'efficienza di coordinamento è migliorata del 21%, la soddisfazione dei clienti del 60%, con oltre il 95% di feedback positivi. Numeri che mi hanno insegnato una cosa: la salute di un'organizzazione si misura, si governa, si progetta.",
        skill: "Leadership · Organizzazione · Gestione dei processi",
      },
      {
        n: "05",
        period: "2014 — 2017",
        title: "Le fondamenta cliniche",
        body: "I primi anni di lavoro clinico in ambito privato sono stati la mia vera scuola di osservazione. Migliaia di casi, ciascuno con una storia diversa: ho imparato a riconoscere i segnali di stress e sovraccarico molto prima che diventino sintomi conclamati. È qui che nasce il rigore scientifico del mio metodo — e la capacità di leggere ciò che i dati, da soli, non dicono ancora.",
        skill: "Rigore scientifico · Lettura dei segnali",
      },
    ],
    network:
      "Ogni progetto è seguito da Eclenia, con il supporto, quando necessario, di una rete selezionata di specialisti (psicologi del lavoro, nutrizionisti, ergonomi).",
    credentials: {
      kicker: "Background scientifico",
      title: "Le fondamenta evidence-based",
      items: [
        "Laurea con lode in Fisioterapia",
        "Master in Riabilitazione Muscoloscheletrica",
        "Formazione continua evidence-based",
        "Corso di specializzazione europea in Work-Wellbeing Management (Erasmus+ KA202)",
      ],
      note: "La formazione clinica è la base scientifica del mio lavoro di consulenza: è ciò che rende ogni raccomandazione verificabile, misurabile e fondata sulle evidenze.",
    },
    eclenia: {
      title: "Perché Eclenia",
      subtitle: "See beyond what is visible.",
      p1: "Il nome nasce dal fenomeno dell'eclissi — un momento in cui la luce non scompare, ma viene temporaneamente oscurata, e per questo invita a guardare con più attenzione.",
      p2: "Molti dei fattori che incidono su salute, benessere e performance restano invisibili prima di diventare un problema. Eclenia nasce per riconoscerli, comprenderli e trasformarli in prevenzione.",
      p3: "Un approccio scientifico e concreto che unisce persone, salute e organizzazione, per ambienti di lavoro più sani, sostenibili e capaci di generare valore.",
    },
    cta: "Prenota una Discovery Call",
  },
  approach: {
    kicker: "L'approccio",
    title: "Il metodo in quattro fasi",
    intro:
      "Ogni percorso segue una struttura chiara, adattabile al contesto di ogni organizzazione.",
    phases: [
      {
        n: "01",
        title: "Fotografia e diagnosi",
        body: "Ogni progetto inizia da una fotografia oggettiva dello stato di salute dell'organizzazione. Raccogliamo dati attraverso questionari validati a livello internazionale e strumenti di assessment strutturati, nel pieno rispetto della privacy delle persone. Senza una diagnosi accurata, ogni intervento è una scommessa.",
        tag: "Assessment · Dati · Privacy",
      },
      {
        n: "02",
        title: "Aree di intervento",
        body: "Leggiamo i dati attraverso un modello a tre livelli — persona, team, organizzazione. Questo permette di distinguere ciò che dipende dai comportamenti individuali da ciò che dipende dai processi e dalla cultura, e di intervenire dove la leva è maggiore.",
        tag: "Persona · Team · Organizzazione",
      },
      {
        n: "03",
        title: "Piano di intervento condiviso",
        body: "Costruiamo il piano insieme alla direzione: obiettivi concreti e verificabili, priorità chiare, risorse definite. La strategia di benessere entra nella governance dell'azienda, non resta un'iniziativa laterale affidata alle buone intenzioni.",
        tag: "Obiettivi · Governance · Direzione",
      },
      {
        n: "04",
        title: "Reporting e monitoraggio continuo",
        body: "Rimisuriamo i risultati nel tempo con gli stessi strumenti della fase iniziale. Report periodici per la direzione, indicatori chiari, correzioni di rotta documentate. La salute diventa un indicatore gestionale, al pari di qualsiasi altra metrica di business.",
        tag: "KPI · Report · Rimisurazione",
      },
    ],
    principles: {
      kicker: "I principi",
      title: "Ciò che non cambia mai",
      items: [
        { title: "Basato sulle evidenze", text: "Ogni nostra raccomandazione poggia su letteratura scientifica e dati raccolti, mai su mode o opinioni." },
        { title: "Privacy by design", text: "I dati delle persone sono trattati con protocolli rigorosi: aggregati, anonimi, protetti." },
        { title: "Misurabilità", text: "Se non si può misurare, non si può governare. Ogni intervento ha indicatori definiti ex ante." },
        { title: "Su misura", text: "Nessun pacchetto standard: ogni organizzazione ha la sua fotografia, le sue priorità, il suo piano." },
      ],
    },
    cta: "Richiedi una fotografia della tua organizzazione",
  },
  expertise: {
    kicker: "Aree di competenza",
    title: "Undici aree, un unico obiettivo: organizzazioni in salute",
    intro:
      "Ogni area può essere un punto di ingresso o parte di una strategia integrata. Il perimetro esatto lo definiamo sempre nella fase di diagnosi.",
    items: [
      { n: "01", title: "Corporate Health", text: "Strategie integrate di salute aziendale: dalla diagnosi dei bisogni alla governance del benessere come asset organizzativo." },
      { n: "02", title: "Organizational Wellbeing", text: "Misurazione e sviluppo del benessere organizzativo: clima, carichi di lavoro, qualità delle relazioni, equilibrio tra domande e risorse." },
      { n: "03", title: "Healthy Workplace Strategy", text: "Progettazione di strategie di lungo periodo che integrano salute, prevenzione e obiettivi di business in un unico piano." },
      { n: "04", title: "Women's Health at Work", text: "Programmi dedicati alla salute delle donne nelle diverse fasi della vita lavorativa, come leva di equità, retention e performance organizzativa." },
      { n: "05", title: "Prevenzione muscoloscheletrica", text: "Programmi di prevenzione basati su evidenze per ridurre l'incidenza dei disturbi muscoloscheletrici legati al lavoro, tra le principali cause di assenza in Europa." },
      { n: "06", title: "Ergonomia", text: "Valutazione e progettazione ergonomica di postazioni, ambienti e processi di lavoro — in ufficio, in produzione e nel lavoro ibrido." },
      { n: "07", title: "Leadership & Wellbeing", text: "Formazione e affiancamento dei leader: la salute di un'organizzazione inizia dai comportamenti di chi la guida." },
      { n: "08", title: "Employee Experience", text: "Progettazione di esperienze di lavoro in cui la salute è integrata nel percorso delle persone, dall'ingresso allo sviluppo." },
      { n: "09", title: "Health Culture", text: "Costruzione di una cultura della salute condivisa, che va oltre i singoli programmi e diventa modo di lavorare." },
      { n: "10", title: "Health Promotion", text: "Iniziative di promozione della salute coerenti con i dati, con la cultura e con gli obiettivi dell'organizzazione." },
      { n: "11", title: "Healthy Ageing Workforce", text: "Strategie per una forza lavoro che invecchia in salute: sostenibilità dei carichi, prevenzione e valorizzazione dell'esperienza." },
    ],
    cta: "Non sai da dove partire? Prenota una Discovery Call",
  },
  insights: {
    kicker: "Insights",
    title: "Analisi, evidenze e prospettive",
    intro:
      "In questa sezione editoriale condividiamo analisi basate sui dati, letture critiche della letteratura scientifica e prospettive strategiche per chi guida le organizzazioni.",
    readTime: "min di lettura",
    readArticle: "Leggi l'articolo",
    backToList: "Tutti gli insights",
    sourcesLabel: "Fonti",
  },
  resources: {
    kicker: "Risorse",
    title: "Strumenti per chi guida il cambiamento",
    intro:
      "Brief, self-assessment e checklist che stiamo progettando per direzioni HR, leader e imprenditori. La libreria è in costruzione: ecco le prime risorse in arrivo.",
    comingSoon: "In arrivo",
    items: [
      {
        type: "Self-Assessment",
        title: "Maturità del benessere organizzativo",
        text: "Uno strumento di autovalutazione per capire a che punto è la tua organizzazione sui tre livelli: persona, team, sistema.",
      },
      {
        type: "Executive Brief",
        title: "Il business case della prevenzione",
        text: "Una sintesi ragionata delle evidenze economiche sulla prevenzione e sul benessere organizzativo, pensata per il board.",
      },
      {
        type: "Checklist",
        title: "Un luogo di lavoro in salute",
        text: "I segnali osservabili di un ambiente di lavoro sano: una checklist operativa per leader e responsabili HR.",
      },
    ],
    cta: "Vuoi essere avvisato quando escono? Scrivici",
  },
  contact: {
    kicker: "Contatti",
    title: "Iniziamo dalla tua organizzazione",
    intro:
      "Il primo passo è una conversazione. Raccontaci il contesto, gli obiettivi e le priorità: ti risponderemo personalmente entro due giorni lavorativi.",
    info: {
      title: "Recapiti",
      locationLabel: "Sede",
      location: "Nove (VI), Veneto — Italia",
      phoneLabel: "Telefono",
      phone: "+39 340 972 6465",
      emailLabel: "Email",
      email: "info@eclenia.com",
      note: "Disponibili per advisory in presenza nel Triveneto e in remoto per organizzazioni italiane e internazionali.",
    },
    form: {
      name: "Nome e cognome",
      namePh: "Il tuo nome",
      company: "Azienda / Organizzazione",
      companyPh: "Nome dell'organizzazione",
      email: "Email",
      emailPh: "nome@azienda.it",
      message: "Messaggio",
      messagePh: "Raccontaci il contesto e gli obiettivi…",
      submit: "Invia la richiesta",
      sending: "Invio in corso…",
      success: "Richiesta inviata. Ti risponderemo personalmente entro due giorni lavorativi.",
      error: "Qualcosa non ha funzionato. Riprova o scrivici direttamente via email.",
    },
    finalCta: "Prenota una Discovery Call",
  },
  modal: {
    title: "Prenota una Discovery Call",
    subtitle: "30 minuti per capire dove si trova la tua organizzazione e dove può arrivare. Ti ricontatteremo per fissare data e orario.",
    success: "Richiesta inviata. Ti ricontatteremo per fissare la call.",
    error: "Qualcosa non ha funzionato. Riprova o scrivici via email.",
    close: "Chiudi",
  },
  footer: {
    claim: "Clinical Science. Strategic Thinking. Human-Centered Organizations.",
    navTitle: "Navigazione",
    contactTitle: "Contatti",
    ctaTitle: "Costruiamo luoghi di lavoro in salute.",
    cta: "Prenota una Discovery Call",
    rights: "© 2026 ECLENIA — Corporate Health & Workplace Wellbeing. Tutti i diritti riservati.",
    location: "Nove (VI), Veneto — Italia",
  },
};

export default it;
